import view from "../views";
const pagesRoutes = [  
  { component: view.Login, path: "/login", exact: true, name: "Login" },
  { component: view.Login, path: "/", exact: true, name: "Login" },
  { component: view.Error404, path: "*", exact: false, name: "Error404" },
];
export default pagesRoutes;
